
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.225 3.735a2.51 2.51 0 013.55 0l6.49 6.49c.98.98.98 2.57 0 3.55l-6.49 6.49c-.98.98-2.57.98-3.55 0l-6.49-6.49a2.51 2.51 0 010-3.55l6.49-6.49z","fill":"#AAA"}})])
          )
        }
      }
    